<template>
    <div class="form-item">
        <label class="label-caption">
            {{ item.nmcaption }}
            <span v-if="isObrigatorio" class="required">*</span>
        </label>

        <select
            :value="item.resposta_opcoes_cditem || item.resposta_opcoes || ''"
            @change="onChange"
        >
            <option value="">Selecione...</option>

            <option
                v-for="opcao in opcoes"
                :key="opcao.value"
                :value="opcao.value"
            >
                {{ opcao.label }}
            </option>
        </select>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { opcoesDoItem } from './docUtils';

const props = defineProps({
    item: {
        type: Object,
        required: true
    },
    opcoesApi: {
        type: Array,
        default: () => []
    }
});

const emit = defineEmits(['update:item']);

const isObrigatorio = computed(() => props.item.ckobrigatorio === 'S');
const opcoes = computed(() => opcoesDoItem(props.item, props.opcoesApi));

function onChange(event) {
    const value = event.target.value || null;
    const opcao = opcoes.value.find(o => o.value === value) || null;

    emit('update:item', {
        ...props.item,
        resposta_opcoes: opcao ? opcao.label : null,
        resposta_opcoes_cditem: opcao ? opcao.value : null
    });
}
</script>

<style scoped>
.required {
    color: #b00020;
    margin-left: 3px;
}
</style>
